// Quién ve qué en el menú y en los paneles internos.
//
// 17 sep 2026. Hasta hoy esta lista estaba copiada a mano en cinco
// archivos (NotionSidebar, Reports, Budgets, StatementImporter,
// TestersPage) y ya había divergido del backend: el frontend tenía a
// augusto@darwinoptima.com como admin y el backend no, así que esa cuenta
// veía el menú de ADMIN y recibía 403 al entrar. Una sola fuente evita
// que vuelva a pasar.
//
// **Esto es solo cosmético.** Sirve para no mostrarle a alguien un link a
// un panel donde no puede entrar. El control de acceso real vive en el
// backend (core/deps.py: get_current_admin y get_current_super_admin,
// alimentados por settings.ADMIN_EMAILS y SUPER_ADMIN_EMAILS). Si esta
// lista se equivoca, lo peor que pasa es un link de más o de menos --
// nunca un dato expuesto.

// Admin: paneles internos (consumo de IA por cliente, consultas
// agendadas, importador sin límite de cuota).
const ADMIN_EMAILS = ['augusto@darwinoptima.com', 'abalarezoc@gmail.com'];

// Admin completo: además, el panel de Cuentas de testing, que regala
// planes Pro+ sin cobrar. Augusto pidió que su cuenta personal tenga
// todo menos eso -- regalar planes es una operación del negocio y
// pertenece a la cuenta de la empresa, no a la cuenta donde lleva sus
// propias finanzas.
const SUPER_ADMIN_EMAILS = ['augusto@darwinoptima.com'];

const emailDe = (user) => (user?.email || '').trim().toLowerCase();

export const esAdmin = (user) => {
  const email = emailDe(user);
  return !!email && ADMIN_EMAILS.includes(email);
};

export const esSuperAdmin = (user) => {
  const email = emailDe(user);
  return !!email && SUPER_ADMIN_EMAILS.includes(email);
};

// La cuenta que se usa para demostraciones: lleva data cargada a
// propósito (ver backend_new/scripts/cargar_demo.py). Se expone como
// concepto aparte de "admin" porque son cosas distintas que hoy
// coinciden: si mañana la demo se muda a otra cuenta, se cambia acá.
export const esCuentaDemo = (user) => emailDe(user) === 'augusto@darwinoptima.com';

export default { esAdmin, esSuperAdmin, esCuentaDemo };
